import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialog,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifySlUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { Validators, AbstractControl } from '@angular/forms';
import { PreAssessmentService } from 'src/app/core/services/api-services/pre-assessments.service';
import { UserService } from '../../services/api-services/user.service';
import { AddReasonForPrscription } from 'src/app/core/modals/add-reason-for-prscription/add-reason-for-prscription.component';
import { AddCourierForPrscriptionComponent } from 'src/app/core/modals/add-courier-for-prscription/add-courier-for-prscription.component';
import { MatRadioButton } from '@angular/material/radio';
enum NotifyType {
  sms = 'sms',
  message = 'message',
  do_not = 'do_not',
}

@Component({
  selector: 'app-prescription-status',
  templateUrl: './prescription-status.component.html',
  styleUrls: ['./prescription-status.component.scss'],
})
export class PrescriptionStatusComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  NotifyType = NotifyType;
  tenant: any = localStorage.getItem('tenant');
  payload: { NotifyUsers: boolean; NotifySlUsersBy: Array<number> } = {
    NotifyUsers: true,
    NotifySlUsersBy: [],
  };
  preSelectedStatuses = [
    'cancelled',
    'confirmed',
    'filled',
    'on hold',
    'pending',
    'received',
    'transferred out',
    'verification in progress',
    'verification in progress attempt1',
    'verification in progress attempt2',
    'request completed',
    'prescriber unavailable',
    'verification delayed'
  ];
  courierStatuses = ['confirmed', 'verification in progress', 'filled'];
  reasonStatuses = ['on hold', 'transferred out', 'cancelled', 'pending information', 'confirmed'];
  reasonList: any[] = [];
  courierList: any[] = [];
  rejectedReasonRequired: boolean = true;
  selectedStatus: any;
  isReasonStatus: boolean = false;
  isCourierStatus: boolean = false;
  showInternalNotes: boolean = false;
  isReasonLoaded: boolean = false;
  isMessageLoaded: boolean = true;
  isPatientMessage: boolean = true;
  hideForQc = false;
  hideReasonBlock: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PrescriptionStatusComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public krollService: KRollService,
    public userService: UserService,
    public preAssessmentService: PreAssessmentService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {
    if (this.tenant == 'qc') {
      this.hideForQc = true;
    }
  }

  ngOnInit(): void {
    this.selectedStatus = this.props.item.receipt.status;
    // this.isCourierStatus = this.courierStatuses.includes(this.selectedStatus);
    this.isReasonStatus = this.reasonStatuses.includes(this.selectedStatus);
    this.hideReasonBlock = (
      this.selectedStatus == 'confirmed' &&
      (this.tenant == 'ml' || this.tenant == 'ml_qc')
    );

    this.initializeForm();
    this.reasonListForPrscriptionStatus();
    this.couriersListForPrscriptionStatus();
    if (!this.isReasonStatus) {
      this.getCustomeMessage();
    }
    this.form.get('reason_id')?.valueChanges.subscribe((change: any) => {
      if (change != null || change != undefined) {
        this.showInternalNotes = true;
        this.isMessageLoaded = false;
        this.onReasonChange();
      } else {
        this.showInternalNotes = false;
      }
    })
  }

  onCheckChange(event: MatCheckboxChange) {
    const customMessageControl = this.form.get('custom_message');
    if (customMessageControl) {
      if (event.checked) {
        this.addNotifyControl();
      } else {
        // Set custom_message control value to false
        customMessageControl.setValue(false);
        this.form.removeControl('NotifyUsersBy');
      }
    }
  }
  onCheckMessage(event: MatCheckboxChange) {
    const validators = this.getConditionalValidators(); // Get the updated validators
    this.form.controls['message'].setValidators(validators); // Set the validators for the 'message' control
    this.form.controls['message'].updateValueAndValidity(); // Update the value and validity of the control
  }

  private shouldRequireReason(): boolean {
    return this.isReasonStatus && !(this.selectedStatus === 'confirmed' && (this.tenant === 'ml' || this.tenant === 'ml_qc'));
  }

  initializeForm() {
    let { NotifyUsers } = this.payload;
    const isCustomMessageSelected = false;
    const rejectedReasonValidators = this.preSelectedStatuses.includes(this.selectedStatus) ? [Validators.required] : [Validators.nullValidator];
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
      custom_message: new FormControl({ value: isCustomMessageSelected, disabled: this.isReasonStatus }),
      //RejectedReasonID: new FormControl("", rejectedReasonValidators),
      courier_id: new FormControl('', this.isCourierStatus ? [Validators.required] : []),
      reason_id: new FormControl(null, this.shouldRequireReason() ? [Validators.required] : []),
      internal_notes: new FormControl(''),
      message: new FormControl('', this.getConditionalValidators()),
      NotifyUsersBy: this.fb.array([]),
    });
    this.addNotifyControl();
  }

  isCustomMessageVisible(): boolean {
    return this.preSelectedStatuses.includes(this.props.item.receipt.status);
  }

  getConditionalValidators() {
    return (control: AbstractControl) => {
      if (
        this.form.get('custom_message')?.value &&
        this.form.get('NotifyUsers')?.value
      ) {
        return Validators.required(control);
      } else {
        return null; // If custom_message is unchecked, disable the validation.
      }
    };
  }

  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl(
      'NotifyUsersBy',
      this.fb.array([], arrayMinLengthByKey(1, 'isChecked'))
    );
    NotifySlUsersBy.forEach((x: any) => {
      this.notifyByArray.push(
        this.fb.group({
          id: new FormControl(x.id),
          value: new FormControl(x.value),
          isChecked: new FormControl(x.isChecked),
          disable: new FormControl(false),
        })
      );
    });
  }

  formSubmit() {
    this.isLoading = true;
    const reasonControl = this.form.get('reason_id');
    const requireReason = this.shouldRequireReason();
    reasonControl?.setValidators(requireReason ? [Validators.required] : []);
    reasonControl?.updateValueAndValidity();
    if (requireReason && !reasonControl?.value) {
      this.toast.error('Please select reason');
      this.isLoading = false;
      return;
    }
    // Check if the form is valid before proceeding
    if (this.form.valid) {
      let payload: {
        id: any;
        reason_id: any;
        courier_id: any;
        user_id: string;
        status: string;
        type: string;
        CustomMessage: boolean;
        Message?: string;
        NotifyUsers: boolean;
        NotifyUsersBy: any;
        internal_notes: any,
      } = {
        id: this.props.item.id,
        reason_id: this.form.value.reason_id,
        courier_id: this.form.value.courier_id,
        user_id: this.props.item.user_id,
        status: this.props.item.receipt.status,
        type: this.props.item.receipt.status,
        CustomMessage: this.form.get('custom_message')?.value,
        Message: encodeURIComponent(this.form.get('custom_message')?.value ? this.form.get('message')?.value : ''),
        NotifyUsers: this.form.value.NotifyUsers,
        // NotifyUsersBy: this.form.value.NotifyUsersBy,
        NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
        internal_notes: this.form.value.internal_notes
      };
      this.isLoading = true;
      // API call to update delivery status
      this.preAssessmentService.changePrescriptionStatus(payload).subscribe(
        (res) => {
          if (res.body.success) {
            // Display success message
            this.toast.success(res.body.message);
            this.dialogRef.close({ payload: payload, response: res.body });
            this.isLoading = false;
          } else {
            // Display error message
            this.toast.error(res.body.message);
            this.isLoading = false;
          }
        },
        (err) => {
          // Display error message for API error
          this.isLoading = false;
          this.toast.error('An error occurred while updating delivery status.');
          this.dialogRef.close({ payload: payload, response: err?.body });
        }
      );
    } else {
      this.isLoading = false;
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

  couriersListForPrscriptionStatus() {
    let payload = {
      type: this.props.item.receipt.status,
    };
    this.preAssessmentService
      .couriersListForPrscriptionStatus(payload)
      .subscribe((res) => {
        if (res?.body?.success) {
          this.courierList = res?.body?.data;
        } else {
          this.courierList = [];
        }
      });
  }
  openAddCourierDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = this.props;
    if (window.innerWidth < 768) {
      dialogConfig.width = '90%';
    } else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(
      AddCourierForPrscriptionComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res.response.success) {
        this.couriersListForPrscriptionStatus();
        this.form.controls.courier_id.setValue(res.response.data.id);
      }
    });
  }

  reasonListForPrscriptionStatus() {
    let payload = {
      type: this.props.item.receipt.status,
      reason_from: this.props.item.receipt.status == 'confirmed' ? 4 : this.props.client_id == 2 ? 3 : 2 // 3 for client_id 2 block, 2 for other blocks
    };
    this.preAssessmentService
      .reasonListForPrscriptionStatus(payload)
      .subscribe((res) => {
        if (res?.body?.success) {
          this.reasonList = res?.body?.data;
          this.isReasonLoaded = true;
        } else {
          this.reasonList = [];
          this.isReasonLoaded = true;
        }
      });
  }
  openAddRasonDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = this.props;
    if (window.innerWidth < 768) {
      dialogConfig.width = '90%';
    } else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(AddReasonForPrscription, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res.response.success) {
        this.reasonListForPrscriptionStatus();
        this.form.controls.reason_id.setValue(res.response.data.id);
      }
    });
  }

  getCustomeMessage() {
    let payload = {
      type: this.props.item.receipt.status,
    };
    this.preAssessmentService.getCustomeMessage(payload).subscribe((res) => {
      if (res?.body?.success) {
        const customMessage = res?.body?.data?.template ? res?.body?.data?.template : '';
        // Set the value of 'message' field in the form
        this.form.patchValue({ message: customMessage });
      } else {
        this.form.patchValue({ message: '' });
      }
    });
  }

  onReasonChange() {
    const payload: any = {
      reason_id: this.form.get('reason_id')?.value,
      item_type: this.props.client_id == 2 ? 3 : 2, // 3 for client_id 2 block, 2 for other blocks
      type: this.selectedStatus,
      user_id: this.props.item.user_id
    }
    try {
      this.preAssessmentService.getPatientFacingContent(payload).subscribe((res: any) => {
        if (res.body.success) {
          this.form.get('message')?.setValue(res?.body?.data?.patient_facing_text);
          this.form.get('custom_message')?.setValue(res?.body?.data?.patient_facing_text ? true : false);
          this.form.value.custom_message = true;
          this.form.get('message')?.disable();
          this.form.get('custom_message')?.disable();
          this.isMessageLoaded = true;
          this.isPatientMessage = res?.body?.data?.patient_facing_text ? true : false
        } else {
          this.toast.error(res.body.message);
        }
      })
    } catch (err) {
      console.log(err)
      this.toast.error('Something went wrong');
    }
  }
}
